module.exports = __webpack_public_path__ + "static/media/newlogowintell.c131be7d.png";